import script from "./avalibilityHotel.vue?vue&type=script&setup=true&lang=js"
export * from "./avalibilityHotel.vue?vue&type=script&setup=true&lang=js"

import "./avalibilityHotel.vue?vue&type=style&index=0&id=91243eba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91243eba"]])

export default __exports__